module.exports = __webpack_public_path__ + "static/media/spotify.7451de25.svg";